import { render, staticRenderFns } from "./Sparkbar.vue?vue&type=template&id=86b347e2&"
import script from "./Sparkbar.vue?vue&type=script&lang=js&"
export * from "./Sparkbar.vue?vue&type=script&lang=js&"
import style0 from "./Sparkbar.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports